import { Link } from "react-router-dom";
import { Skull } from "lucide-react";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="relative flex min-h-[calc(100vh-73px)] flex-col items-center justify-center px-6 text-center"
    >
      <div className="grid-noise pointer-events-none absolute inset-0 opacity-[0.06]" />
      <div className="relative">
        <Skull className="mx-auto h-12 w-12 text-[#D92D20]" strokeWidth={1.5} />
        <div className="meta-label mt-6 text-[#737373]">Error / 404 / Redacted</div>
        <h1 className="mt-3 font-heading text-6xl tracking-tighter text-white">Page classified.</h1>
        <p className="mx-auto mt-4 max-w-md font-body text-[#A3A3A3]">
          This file doesn't exist in the archive — it may have been moved, redacted, or never declassified.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="btn-cta mt-8 inline-block px-6 py-3"
        >
          Return to the archive
        </Link>
      </div>
    </div>
  );
}
